import React from 'react'
import styled, { keyframes } from 'styled-components'

import { white } from './colors'

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`

const StyledLoader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  margin: 0 auto;
  &:after {
    content: ' ';
    display: block;
    width: ${({ size }) => size - 20}px;
    height: ${({ size }) => size - 20}px;
    margin: 1px;
    border-radius: 50%;
    border: 5px solid ${({ color }) => color};
    border-color: ${({ color }) => color} transparent ${({ color }) => color}
      transparent;
    animation: ${rotate} 1.2s linear infinite;
  }
`

const Loader = ({ size = 54, color = white, style }) => (
  <StyledLoader size={size} color={color} style={style} />
)

export default Loader
